module.exports = __webpack_public_path__ + "static/img/space1.1e8bad3d.png";